
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import Puzzle from 'react-image-puzzle';
import BlockPuzzle from './blockPuzzle'
import axios from 'axios';

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";

export default class PuzzleGame extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			logged: false,
			// alreadyPlayed: document.getElementById("puzzle-game-canvas").getAttribute("alreadyPlayed") === "true" ? true : false,
			alreadyPlayed:  false,
			remainingTime: document.getElementById("puzzle-game-canvas").getAttribute("maxTime") || 90,
			started: false,
			ended: false,
			img: document.getElementById("puzzle-game-canvas").getAttribute("imgUrl") || "",
			sponsorImage: document.getElementById("puzzle-game-canvas").getAttribute("sponsor") || "",

			puzzleData:{
				//	imgPzzuleGame : document.getElementById("puzzle-game-canvas").getAttribute("imgUrlPuzzle") ||
					// 	"https://images.unsplash.com/photo-1494548162494-384bba4ab999?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80" ,
				imgPzzuleGame:"https://i.guim.co.uk/img/media/26392d05302e02f7bf4eb143bb84c8097d09144b/446_167_3683_2210/master/3683.jpg?width=1200&height=1200&quality=85&auto=format&fit=crop&s=49ed3252c0b2ffb49cf8b508892e452d" ,

				cod_sconto:  "cod_sconto",
				size:600,
				visible:'',
				msgWin: "Complimenti hai vinto!",
				msgLose: "Peccato riprova ancora!",
				coding:"9ask9ka"
			}
		}

		this.mainView = this.mainView.bind(this)

	}

	componentDidMount() {

		 this.setState(
			 { logged: document.getElementById("puzzle-game-canvas").getAttribute("logged") === "true" ? true : false }
		 )

		this.mywin = this.mywin.bind(this);
		//autostart

		//this.start();
	}

	start() {
		let { puzzleData } = this.state;
		puzzleData.visible = "startgame";
		this.setState({started: true, puzzleData}, () => {
			setInterval(() => {
				if(this.state.started && !this.state.ended)
					if(this.state.remainingTime === 1)
						this.setState({
							remainingTime: this.state.remainingTime - 1,
							started: true,
							ended:   true,
						}, () => {
							this.end();
						});
					else
						this.setState({
							remainingTime: this.state.remainingTime - 1
						});
			}, 1000);
		});
	}

	end(win = false) {
		if(win) {
/*			this.setState({
				remainingTime: document.getElementById("puzzle-game-canvas").getAttribute("maxTime") || 90,
				started: true,
				ended:   true,

				puzzleData:{
					visible:'wingame'
				}
			})*/
		}
		else {
			this.setState({
				remainingTime: document.getElementById("puzzle-game-canvas").getAttribute("maxTime") || 90,
				started: true,
				ended:   true,

				puzzleData:{
					visible:'losegame'
				}
			}, () => {
				//this.registerPartecipant(false);
			})
		}
	}

	shareOn(platform) {
		const url = window.location.href;
		switch(platform) {
			case "facebook": window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(url)+'&t='+encodeURIComponent('Trova anche tu le differenze!'),'sharer','toolbar=0,status=0,width=626,height=436');
				break;
			case "twitter": window.open("https://twitter.com/home?status="+encodeURIComponent(url))
				break;
			case "whatsapp": window.location.href = "whatsapp://send?text=" + encodeURIComponent(url)
				break;
		}
	}

	checkInstantWin() {
		this.registerPartecipant(true).then(isWinner => {
			if(isWinner)
				this.setState({
					puzzleData:{
						visible:'win_instantwin'
					}
				});
			else
				this.setState({
					puzzleData:{
						visible:'lose_instantwin'
					}
				});
		});
	}

	mywin() {

		let codiceSconto  = document.getElementById("puzzle-game-canvas").getAttribute("code_sconto");
		this.setState({
			/* stop timer se vittoria  */
			started: true,
			ended: true,
			puzzleData: {
				visible: 'wingame',
				cod_sconto: codiceSconto
			}
		});
	}

	mainView(){
		if( this.state.logged ){

			// if(this.state.alreadyPlayed)
			// 	return (
			// 		<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
			// 			<h4 style={{color: "#ffffff", fontWeight: "bold", marginTop: "2em", textAlign: "center"}}>Hai già partecipato a questo gioco!</h4>
			// 		</div>
			// 	);

			if(!this.state.puzzleData.visible) {

				return (
					<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
						<button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => this.start()} >
							Clicca per far partire il tempo e iniziare a giocare!
						</button>
					</div>
				);

			} else if ( this.state.puzzleData.visible == 'startgame' ) {
				return (<BlockPuzzle mywin = { this.mywin } /> )

			} else if ( this.state.puzzleData.visible == 'wingame' ) {
				return (
					<div className={"win_block"}>
						<img src={ASSETS_BASE + "/images/dog_lose.png"} style={{ maxWidth:'320px',width:'100%'}}/>
						<div className={'body-win-block'}>
							<p style={{ color: '#EA2328', fontSize:'30px',fontWeight:'bold' }}>WOW, SEI UN LAMPO</p>
							<p style={{  fontSize:'20px',margin:'8px 0px' }} >
							Hai ricostruito il puzzle. Grazie per aver partecipato, ecco il codice sconto da utilizzare su purinashop.it:
								</p>
								<h3 style={{ fontWeight:'bold',fontSize:'25px' }}>Beyond10</h3>
								<p style={{ fontSize:'20px',margin:'8px 0px' }} >Il buono ti da diritto a uno sconto del 10% sugli acquisti effettuati tra dal 1° febbraio al 28 febbraio sul Purinashop, solo sui prodotti per cane Beyond.</p>
						</div>
						<a style={{padding:'10px 15px'}} className={'btn-condividi'} href={'http://www.purinashop.it/brand/cane/beyond'} >Vai al Purinashop</a>
						<a style={{padding:'10px 15px'}} className={'btn-condividi'} href={'/giochi/puzzle-beyond'} >Gioca di nuovo</a>
					</div>
				)
			}
			//  else if(this.state.puzzleData.visible == 'win_instantwin') {
			// 	return(

			// 		<div className={"win_block"}>
			// 			<img src={ASSETS_BASE + "/images/dog.png"} style={{ maxWidth:'320px',width:'100%'}}/>
			// 			<div className={'body-win-block'}>
			// 				<p style={{ color: '#EA2328', fontSize:'30px',fontWeight:'bold' }}>
			// 					COMPLEMENTI, OGGI E’ UN GIORNO FORTUNATO!
			// 				</p>

			// 				<p style={{  fontSize:'23px',margin:'8px 0px' }} >
			// 					Hai vinto un prodotto omaggio PURINA® BEYOND® per il tuo cane.  <br/>
			// 					<b>Riceverai presto una mail con il dettaglio della vincita.</b>
			// 				</p>
			// 			</div>
			// 			<button onClick={() => this.shareOn("facebook")} className={"btn play-game-button"}>Condividi il gioco</button>
			// 		</div>
			// 	)
			// } 
			else if(this.state.puzzleData.visible == 'losegame') {
				
				return(

						<div className={"win_block"}>
							<img src={ASSETS_BASE + "/images/dog_lose.png"} style={{ maxWidth:'320px',width:'100%'}}/>
							<div className={'body-win-block'}>
								<p style={{ color: '#EA2328', fontSize:'30px',fontWeight:'bold' }}>
									PECCATO, NON HAI RICOSTRUITO IL PUZZLE.
								</p>
								<p style={{  fontSize:'20px',margin:'8px 0px' }} >
									Grazie comunque per aver giocato con noi, ecco il codice sconto da utilizzare su purinashop.it:
								</p> 

								<h3 style={{ fontWeight:'bold',fontSize:'25px' }}>Beyond10</h3>
								<p style={{  fontSize:'20px',margin:'8px 0px' }} >
									Il buono ti da diritto a uno sconto del 10% sugli acquisti effettuati tra dal 1° febbraio al 28 febbraio sul Purinashop, solo sui prodotti per cane Beyond.
								</p>
							</div>
							<a style={{padding:'10px 15px'}} className={'btn-condividi'} href={'http://www.purinashop.it/brand/cane/beyond'} >Vai al Purinashop</a>
						<a style={{padding:'10px 15px'}} className={'btn-condividi'} href={'/giochi/puzzle-beyond'} >Gioca di nuovo</a>
						</div>
				)
			}
			//  else if(this.state.puzzleData.visible == "lose_instantwin") {

			// 	return(

			// 		<div className={"win_block"}>
			// 			<img src={ASSETS_BASE + "/images/dog_lose.png"} style={{ maxWidth:'320px',width:'100%'}}/>
			// 			<div className={'body-win-block'}>
			// 				<p style={{ color: '#EA2328', fontSize:'30px',fontWeight:'bold' }}>
			// 					PECCATO, NON SEI STATO FORTUNATO.
			// 				</p>

			// 				<p style={{  fontSize:'23px',margin:'8px 0px' }} >
			// 					Gioca di nuovo e tenta la fortuna, ogni giorno, fino 07/02/2020, puoi provare a vincere un omaggio  PURINA® BEYOND® per il tuo cane!
			// 				</p>
			// 			</div>
			// 			<button className={'btn-condividi'} onClick={() => window.location.reload()}>TORNA AL GIOCO</button>
			// 		</div>
			// 	)

			// }

		} else{
			return(
				<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
					<button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
						Accedi / Registrati per giocare!
					</button>
				</div>
			)
		}
	}

	registerPartecipant(win) {
		return new Promise((resolve, reject) => {
			axios.post(`?winner=${win ? 1 : 0}&instant=1`).then(response => {
				if(response.data == 1)
					resolve(true)
				else
					resolve(false);
			}).catch(e => {
				resolve(false);
			});
		})

	}

	render() {

		const { remainingTime, started, maxClicks, remainingClicks, differences, spottedDifferences, img1, img2, logged, sponsorImage } = this.state;

		return (
			<Fragment>

				<div className={"header"} style={{width: '100%'}}>

					<div className={"container"}  >

						<div className={"logo"}>
							<img style={{width:'255px'}} src={sponsorImage} alt=""/>
						</div>

						{started && (
							<div className={"flex j-center a-center"}>
								<div className={"time flex j-center a-center"}>
									<img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} />
									<span className={"time-remaining"}>
										TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
									</span>
								</div>
							</div>
						)}

						<div className={"row"} style={{marginTop:'25px'}} >
							<div  className={'col-md-2  left-img'} >
								{
									this.state.started &&(
									<img  style={{ width: '115px' }} src={ASSETS_BASE + "/images/dog.png"}  />
									)

								}
								 
							</div>

							{ this.mainView() }


							{ /*<div className={'col-md-8 col-sm-12 col-xs-12 mainview'}>
								{
									this.mainView()
								}
							</div>*/ }

							{/*<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
								<button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
									Accedi / Registrati per giocare!
								</button>
							</div>*/}

							{/*<div className={'col-md-2 right-img'}  >
								<img src={ASSETS_BASE + "/images/dog.png"}  />
							</div>*/}

 							  {/*MOBILE SHOW/HIDE */}
							<div className={'col-6 left-img-mobile'} >
								<img className={'img-left-cat'} src={ASSETS_BASE + "/images/dog-puzzle-game-5.png"}  />
							</div>


							<div className={'col-6 right-img-mobile'}  >
								<img className={'img-right-dog'} src={ASSETS_BASE + "/images/dog.png"}  />
							</div>
							  {/*MOBILE*/}


					{/*		{
								this.state.puzzleData.visible  ? (

								<BlockPuzzle mywin = { this.mywin } />

							) : (
								<div className={"win_block"}>
									Complimenti hai vinto!
									Ecco il tuo codice sconto [ { this.state.puzzleData.cod_sconto } ]
								</div>
							)}*/}


							{/*		{

								this.state.puzzleData.visible  ? (

								<BlockPuzzle mywin = { this.mywin } />

							) : (
								<div className={"win_block"}>
									Complimenti hai vinto!
									Ecco il tuo codice sconto [ { this.state.puzzleData.cod_sconto } ]
								</div>
							)}*/}


						</div>
						{/*	<div id={'cat-dog-mobile'} style={{ width:'100%',backgroundColor:'#333333'  }}>
						 <div  className={'cat-mobile'}>
								 <img src={ASSETS_BASE + "/images/cat.png"} />
							 </div>
							<div   className={'dog-mobile'} >
								<img src={ASSETS_BASE + "/images/dog.png"}  />
							</div>
						</div> */}
					</div>
				</div>


				{/* 	<div className={'end-image-puzzle'}>
					<img src={ ASSETS_BASE +"/images/dog-cat-end-page.png" } alt=""/>
				</div>*/}

				{/* GAME CANVAS */}
				<div className={"game-canvas"}>
					<div className={"container"}>
						{/* --PUZZLE QUI-- */}
					</div>
				</div>

			</Fragment>
		);
	}

}

const Timer = ({ remainingTime }) => {
	const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
	const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
	return (
		<Fragment>
			{mins}:{secs}
		</Fragment>
	);
}


document.addEventListener("DOMContentLoaded", () => {
	const mountPoint = document.getElementById("puzzle-game-canvas");
	if(mountPoint)
		ReactDOM.render(<PuzzleGame />, mountPoint);
});
